import React from 'react'

export const SearchLargeIcon = ({ className }: { className: string }) => {
  return (
    <svg
      width='21'
      height='21'
      viewBox='0 0 21 21'
      fill='none'
      className={className}
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M18.4417 17.5575L14.53 13.6459C15.525 12.4534 16.125 10.9208 16.125 9.25C16.125 5.45917 13.0408 2.375 9.25 2.375C5.45917 2.375 2.375 5.45917 2.375 9.25C2.375 13.0408 5.45917 16.125 9.25 16.125C10.9208 16.125 12.4533 15.525 13.6458 14.53L17.5575 18.4417C17.6792 18.5634 17.8392 18.625 17.9992 18.625C18.1592 18.625 18.3192 18.5642 18.4408 18.4417C18.6858 18.1975 18.6858 17.8017 18.4417 17.5575ZM3.625 9.25C3.625 6.14833 6.14833 3.625 9.25 3.625C12.3517 3.625 14.875 6.14833 14.875 9.25C14.875 12.3517 12.3517 14.875 9.25 14.875C6.14833 14.875 3.625 12.3517 3.625 9.25Z'
        fill='black'
        stroke='black'
        strokeWidth='0.5'
      />
    </svg>
  )
}
